import axios from 'axios'

export default {
  namespaced: true,

  state: {
    workClientProjectsClientBillStatuses: [
      {
        status: 'new',
        translation: 'created',
        color: '#277FAF'
      },
      {
        status: 'import_in_progress',
        translation: 'import_in_progress',
        color: '#F2C94C'
      },
      {
        status: 'error',
        translation: 'error',
        color: '#EB5757'
      },
      {
        status: 'imported',
        translation: 'imported',
        color: '#33B0AA'
      },
      {
        status: 'deleted',
        translation: 'deleted',
        color: '#EB5757'
      },
      {
        status: 'sent',
        translation: 'sent',
        color: '#f5a967'
      },
      {
        status: 'pending_payment',
        translation: 'pending_payment',
        color: '#F2994A'
      },
      {
        status: 'paid_partly',
        translation: 'part_paid',
        color: '#A5EEB3'
      },
      {
        status: 'paid',
        translation: 'paid',
        color: '#219653'
      },
    ],
    workClientProjectsClientBillsGrid: {
      grid: {
        data: []
      },
      statistic: {
        statuses: {}
      },
      filter: {
        clients: {}
      }
    },
    workClientProjectsClientBillsShow: {},
    workClientProjectsClientBillsShowTax: {}
  },

  getters: {
    workClientProjectsClientBillStatuses: (state) => {
      return state.workClientProjectsClientBillStatuses
    },
    workClientProjectsClientBillsGrid: (state) => {
      return state.workClientProjectsClientBillsGrid
    },
    workClientProjectsClientBillsShow: (state) => {
      return state.workClientProjectsClientBillsShow
    },
    workClientProjectsClientBillsShowTax: (state) => {
      return state.workClientProjectsClientBillsShowTax
    },
  },

  mutations: {
    setWorkClientProjectsClientBillsGrid(state, payload) {
      state.workClientProjectsClientBillsGrid = payload
    },
    setWorkClientProjectsClientBillsShow(state, payload) {
      state.workClientProjectsClientBillsShow = payload
    },
    setWorkClientProjectsClientBillsShowTax(state, payload) {
      state.workClientProjectsClientBillsShowTax = payload
    },
  },

  actions: {
    onWorkClientProjectsClientBillsGrid({commit, rootState}, {limit, page, client, project, week, status}) {
      return new Promise((resolve, reject) => {
        let url = rootState.apiDomain + '/api/admin/work/client/project/client-bill/bill/grid' +
          '?limit=' + String(limit ? limit : 0) +
          '&page=' + String(page ? page : 1)
        if (client) url = url + '&filter[]=client_ids:' + client
        if (project) url = url + '&filter[]=project_id:' + project
        if (week) url = url + '&filter[]=week_number:' + week
        if (status) url = url + '&filter[]=bill_status:' + status
        axios({
          url: url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientProjectsClientBillsGrid', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsClientBillShow({commit, rootState}, {id}) {
      commit('setLoadingAnimationFullPage', true, { root: true })
      commit('setWorkClientProjectsClientBillsShow', {})
      return new Promise((resolve, reject) => {
        let url = rootState.apiDomain + '/api/admin/work/client/project/client-bill/bill/' + id
        axios({
          url: url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientProjectsClientBillsShow', resp.data)
            commit('setWorkClientProjectsClientBillsShowTax', resp.data)
            commit('setLoadingAnimationFullPage', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimationFullPage', false, { root: true })
            reject(err)
          })
      })
    },
    onWorkClientProjectsClientBillShowToSign({commit, rootState}, {id}) {
      commit('setWorkClientProjectsClientBillsShow', [])
      return new Promise((resolve, reject) => {
        let url = rootState.apiDomain + '/api/admin/work/client/project/client-bill/sign/' + id
        axios({
          url: url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientProjectsClientBillsShow', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsClientBillUpdate({commit, rootState}, {id, data}) {
      commit('setLoadingAnimationFullPage', true, { root: true })
      return new Promise((resolve, reject) => {
        let url = rootState.apiDomain + '/api/admin/work/client/project/client-bill/bill/' + id
        axios({
          url: url,
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            commit('setWorkClientProjectsClientBillsShow', resp.data)
            commit('setLoadingAnimationFullPage', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimationFullPage', false, { root: true })
            reject(err)
          })
      })
    },
    onWorkClientProjectsClientBillUpdateTaxes({commit, rootState}, {id, data}) {
      commit('setLoadingAnimationFullPage', true, { root: true })
      return new Promise((resolve, reject) => {
        let url = rootState.apiDomain + '/api/admin/work/client/project/client-bill/bill/taxes/' + id
        axios({
          url: url,
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            commit('setWorkClientProjectsClientBillsShowTax', resp.data)
            commit('setLoadingAnimationFullPage', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimationFullPage', false, { root: true })
            reject(err)
          })
      })
    },
    onWorkClientProjectsClientBillUpdateStatus({commit, rootState}, {id, status}) {
      commit('setLoadingAnimationFullPage', true, { root: true })
      return new Promise((resolve, reject) => {
        let url = rootState.apiDomain + '/api/admin/work/client/project/client-bill/bill/status/' + id + '/' + status
        axios({
          url: url,
          method: 'PUT',
        })
          .then((resp) => {
            commit('setLoadingAnimationFullPage', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimationFullPage', false, { root: true })
            reject(err)
          })
      })
    },
    onWorkClientProjectsClientBillSend({commit, rootState}, {id}) {
      commit('setLoadingAnimationFullPage', true, { root: true })
      return new Promise((resolve, reject) => {
        let url = rootState.apiDomain + '/api/admin/work/client/project/client-bill/bill/send/' + id
        axios({
          url: url,
          method: 'POST',
        })
          .then((resp) => {
            commit('setLoadingAnimationFullPage', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimationFullPage', false, { root: true })
            reject(err)
          })
      })
    }
  }
}
